/* DON'T EDIT THIS FILE: edit original and run build again */ import { ValueChainTenantHandler } from "../../../framework/tenant-handlers/value-chain-tenant-handler.ts";
import { jdTenant } from "./code.ts";
import { jdFullLabel } from "./jdFullLabel.ts";
import { jdLabel } from "./jdLabel.ts";

class JohnDeereTenantHandler extends ValueChainTenantHandler {
  getCode(): string {
    return jdTenant;
  }

  getPathLabel(): string | null {
    return "john-deere";
  }

  getLabel(): string {
    return jdLabel;
  }

  getFullLabel(): string {
    return jdFullLabel;
  }

  getNotificationsFrom(): string {
    return "no-responder@matchfin.ar";
  }

  getCuit(): string | null {
    return "30-70702485-9";
  }

  publishesInMarketplace(): boolean {
    return true;
  }

  supportsRiskMatrix(): boolean {
    return false;
  }
}

const johnDeereTenantHandler = new JohnDeereTenantHandler();
export default johnDeereTenantHandler;
